import * as React from 'react';
import { useQuery } from 'data-fetching-client';
import { GET_OBJECT_TYPE_DEFINITION } from 'flow-doctor-lib/queries/ObjectDefinitionQueries';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ObjectTypeLabel = ({
  lowerCase,
  objectTypeId,
  portalId,
  plural
}) => {
  const isEngagement = objectTypeId === '0-4';
  const {
    loading,
    error,
    data
  } = useQuery(GET_OBJECT_TYPE_DEFINITION, {
    variables: {
      objectTypeId,
      portalId
    },
    skip: isEngagement
  });
  if (isEngagement) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.references.object.engagement"
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.references.object.unknownObject",
      options: {
        objectTypeId
      }
    });
  }
  if (loading || !data) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 48
    });
  }
  const preferredLabel = plural ? data.objectTypeDefinition.pluralForm : data.objectTypeDefinition.singularForm;
  const preferredLabelWithCase = preferredLabel && lowerCase ? preferredLabel.toLowerCase() : preferredLabel;
  return /*#__PURE__*/_jsx("span", {
    children: preferredLabelWithCase || data.objectTypeDefinition.name || data.objectTypeDefinition.objectTypeId
  });
};
export default ObjectTypeLabel;